import { useEffect } from "react";
import PropTypes from "prop-types";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { ALERT_TYPE, BRANDS, CABINS } from "app/constants";
import { FormattedMessage } from "react-intl";
import { useAnalytics } from "app/utils/analytics/useAnalytics";

export const shouldShowPremiumEconomyWarning = ({ hasCabins, brand, cabinFallback, cabinCode }) =>
	hasCabins && brand === BRANDS.EK && !cabinFallback && cabinCode === CABINS.PREMIUM;

const PremiumEconomyWarning = ({ cabinLabel }) => {
	const { track } = useAnalytics();

	useEffect(() => {
		track("cabin_premium_economy_warning_displayed", { cabinCode: CABINS.PREMIUM });
	}, []);

	return (
		<div className="search-form__cabin-warning">
			<AlertMessage
				alertType={ALERT_TYPE.INFO}
				message={
					<FormattedMessage
						id="sdp.search.cabin.premium.economy.warning"
						values={{ cabinLabel }}
					/>
				}
			/>
		</div>
	);
};

PremiumEconomyWarning.propTypes = {
	cabinLabel: PropTypes.string,
};

export default PremiumEconomyWarning;
